var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", staticStyle: { height: "100%" } },
    [
      _c("breadcrumb-top", {
        attrs: { breadcrumbConfig: _vm.dataList, isBack: "1" },
      }),
      _c(
        "div",
        {
          staticClass: "content c-top",
          staticStyle: { height: "calc(100% - 60px)", position: "relative" },
        },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "el-table",
            {
              ref: "theTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": {
                  background: "#F5F6FA",
                  textAlign: "left",
                  color: "#303033",
                },
                toggleRowExpansion: { expanded: true },
                "row-style": { height: "100px" },
              },
            },
            [
              _c(
                "el-table-column",
                {
                  attrs: {
                    label: "佣金类型",
                    prop: "type",
                    align: "center",
                    width: "300",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c("div", { staticStyle: { "text-align": "left" } }, [
                            _vm._v(_vm._s(props.row.type)),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c("div", { staticStyle: { "line-height": "30px" } }, [
                        _vm._v("佣金类型"),
                      ]),
                    ]),
                  ]),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    label: "普通商品比例",
                    prop: "amount",
                    "min-width": "50",
                    align: "left",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c(
                            "el-input",
                            {
                              staticStyle: { width: "80%" },
                              attrs: {
                                placeholder: "请输入佣金比例",
                                size: "small",
                              },
                              model: {
                                value: props.row.normalCommissionProportion,
                                callback: function ($$v) {
                                  _vm.$set(
                                    props.row,
                                    "normalCommissionProportion",
                                    $$v
                                  )
                                },
                                expression:
                                  "props.row.normalCommissionProportion",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { "margin-top": "4px" },
                                  attrs: { slot: "suffix" },
                                  slot: "suffix",
                                },
                                [_vm._v("%")]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("div", { staticStyle: { "line-height": "30px" } }, [
                          _vm._v("普通商品比例"),
                        ]),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content:
                                "设置的总比例（自返佣金+一级佣金）建议低于服务商比例" +
                                _vm.tableData[0].normalPlatformProportion +
                                "%",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-top": "6px",
                                  "margin-left": "4px",
                                },
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "18px",
                                    height: "18px",
                                  },
                                  attrs: {
                                    src: require("../../../assets/icon/icon_qipao.png"),
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    label: "说明",
                    prop: "remark",
                    "min-width": "50",
                    align: "left",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c("div", { staticStyle: { "text-align": "left" } }, [
                            _vm._v(_vm._s(props.row.remark)),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c("div", { staticStyle: { "line-height": "30px" } }, [
                        _vm._v("说明"),
                      ]),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "bottom-box" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "184px" },
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.updateCommissionConfig },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }